<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">
        <div class="columns">
            <div class="column is-3"><button class="button is-medium is-fullwidth" v-on:click="goManageClasses()">Classes/Departments &amp; Users</button></div>
            <div class="column is-3"><button class="button is-medium is-fullwidth" v-on:click="goManageTeachers()">Teachers/Supervisors</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageBehaviors()">Items</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageNotifications()">Notifications</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth is-primary">Groups</button></div>
            <!-- <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageBadges()">Badges</button></div> -->
        </div>
        
        <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
                <li>
                    <a v-on:click="goManageGroups()">Groups</a>
                </li>
                <li>
                    <a href="#">{{ groupName }}</a>
                </li>
                <li class="is-active">
                    <a href="#" aria-current="page">Member List</a>
                </li>
            </ul>
        </nav>

        <div class="columns">
            <div class="column is-12">
                <div class="card">
                    <loading :active.sync="isLoading" 
                        :can-cancel="false" 
                        :is-full-page="false">
                    </loading>
                    <div class="card-header">
                        <p class="card-header-title">Import member list</p>
                    </div>
                </div>
                <div style="padding: 5px;">
                    <div class="columns">
                        <div class="column one-half">                                
                            <multiselect v-model="selectedStudentsToImport" :options="studentsToImport" :close-on-select="false" :multiple="true" :hide-selected="true" label="nameWithKelas" track-by="name" placeholder="Select students/users to bring into this group"></multiselect>                                
                        </div>
                        <div class="column one-half"><button class='button is-info' v-on:click="takeStudents()">Transfer Now</button></div>
                    </div>
                </div>
                <br />
            </div>
        </div>
        
        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">                    
                    <div class="card-header">
                        <p class="card-header-title">Member List</p>
                        <a class="button is-primary" v-on:click="importStudentForm()" style="margin: 5px;" v-show="!importStudent">Import from Excel</a>
                        <a class="button is-warning" v-on:click="closeImportStudentForm()" style="margin: 5px;" v-show="importStudent">Close Import</a>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading1" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <div class="content" v-show="importStudent">                                    
                            <import-students :groupID="groupID"></import-students>
                        </div>
                        <div class="content">
                            <div class="columns" v-for="data in sortByName(dataList)" :key="data.key">
                                <div class="column">{{ data.firstName }} {{ data.lastName }} ({{ data.kelasID.level }} {{ data.kelasID.name }})</div>
                                <div class="column is-1">
                                    <b-button type="is-info is-small is-light" v-on:click="deleteData(data)" style="margin-right: 5px;" icon-right="trash-alt"/>
                                    <!-- <span class='floated trash icon' v-on:click="deleteData(data)"><font-awesome-icon icon="trash-alt" /></span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./../../NewTopMenu";
import AddContent from './AddContent';
import DataList from './DataList';
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Multiselect from 'vue-multiselect'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ImportStudents from './ImportStudents';

export default {
    name: "ManageGroupsStudents",
    components: {
        NewTopMenu,
        Loading,
        AddContent,        
        Multiselect,
        DataList,
        ImportStudents
    },
    data() {
        return {
            groupID: '',
            groupName: '',
            selectedStudentsToImport: [],
            studentsToImport: [{
                _id: '',
                name: '',
                kelasID: '',
                kelasName: '',
            }],
            data : {
                repeatOn : []
            },
            dataList: [],
            input: { },
            isLoading: false,
            isLoading1: false,
            addContent: false,
            importStudent: false
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        this.getStudents()
        this.getStudentsToImport()
    },
    methods: {
        addContentForm(){
            this.addContent = true;
        },
        closeAddContentForm(){
            this.addContent = false;
        },        
        getStudents(){
            let self = this;
            self.isLoading = true;

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/students/list', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: "group",
                categoryID: self.groupID
            })
            .then(response => {
                self.dataList = []
                self.dataList = response.data
                self.isLoading = false;
            })
            .catch(e => {
                console.log("145 Error:" + e)
                self.isLoading = false;
            }) 
        },
        getStudentsToImport(){
            let self = this;
            self.isLoading1 = true;

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/students/list', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: "schoolWithKelasDataAndNotInGroup",
                categoryID: self.groupID
            })
            .then(response => {
                self.studentsToImport = []
                for (var i = 0; i < response.data.length; i++){
                    var obj = {};
                    obj["_id"] = response.data[i]._id;
                    obj["name"] = response.data[i].firstName + " " + response.data[i].lastName;
                    obj["kelasID"] = response.data[i].kelasID._id;
                    obj["kelasName"] = response.data[i].kelasID.level + " " + response.data[i].kelasID.name;
                    obj["nameWithKelas"] = response.data[i].firstName + " " + response.data[i].lastName + " (" + response.data[i].kelasID.level + " " + response.data[i].kelasID.name + ")";
                    self.studentsToImport.push(obj);
                }
                self.isLoading1 = false;
                console.log("self.studentsToImport.length: " + self.studentsToImport.length)
            })
            .catch(e => {
                console.log("178 Error:" + e)
                self.isLoading1 = false;
            }) 
        },
        takeStudents(){
            if (this.selectedStudentsToImport.length < 1){
                this.$swal({
                    type: "error",
                    title: 'Please select the students you want to bring into this group',
                })
                return false;
            }

            let self = this;
            this.$swal({
                title: "Are you sure?",
                text: "Selected students will be taken into this group. Continue?",
                showCancelButton: true,
                confirmButtonText: 'Yes, take them in',
                cancelButtonText: 'No, cancel',
                showCloseButton: true
            }).then((result) => {
                if (result.value){
                    self.isLoading1 = true;
                    this.input.email = localStorage.getItem('email')
                    this.input.sessionID = localStorage.getItem('sessionID')
                    this.input.groupID = self.groupID

                    this.input.selectedStudentsToImport = this.selectedStudentsToImport;

                    axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                    axios.defaults.responseType = 'json'
                    axios.post(process.env.MY_URL + '/api/group/students/in', this.input)
                        .then(response => {
                            self.isLoading1 = false;

                            if (response.data.success == false) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                self.getStudents();
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
            
                                this.selectedStudentsToImport = "";
                            }
                        })
                        .catch(e => {
                            if (e.response.status === 401) {
                                console.log("salah login")
                                this.errors.push("Invalid login")
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            } else {
                                this.errors.push(e)
                                Toast.open({
                                    message: e,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            }
                        })
                }
            })
        },
        deleteData(data) {
            console.log("entering deleteData with")
            console.log(data)

            let self = this;
            this.$swal({
                title: "Are you sure?",
                text: data.firstName + " " + data.lastName + " will be permanently removed from this group. Are you sure?",
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: true
            }).then((result) => {
                if (result.value){

                    const dataIndex = this.dataList.indexOf(data);
                    this.dataList.splice(dataIndex, 1);

                    axios.defaults.responseType = 'json'
                    axios.post(process.env.NEW_ENDPOINT + '/groups/remove/', {
                        token: localStorage.getItem('jwtTokenV2'),
                        email: localStorage.getItem('email'),
                        category: "student",
                        categoryID: data._id,
                        parentCategoryID: self.groupID
                    }).then(response => {
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                        }
                    })
                    .catch(e => {
                        console.log(e.response)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 10000
                            })
                        } else {
                            Toast.open({
                                message: e,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 10000
                            })
                        }
                    })
                }
            })
        },
        importStudentForm(){
            this.importStudent = true;
        },
        closeImportStudentForm(){
            this.importStudent = false;
        },
        sortByName(arrays){
            return _.orderBy(arrays, 'firstName', 'asc');  //we're using the magical lodash function here                  
        },
        goManageClasses(){
            this.$router.push({
                name: "ManageClassesHome"
            });
        },
        goManageStudents(){
            this.$router.push({
                name: "ManageStudentsHome"
            });
        },
        goManageTeachers(){
            this.$router.push({
                name: "ManageTeachersHome"
            });
        },
        goManageBehaviors(){
            this.$router.push({
                name: "ManageBehaviorsHome"
            });
        },
        goManageNotifications(){
            this.$router.push({
                name: "ManageNotificationsHome"
            });
        },
        goManageGroups(){
            this.$router.push({
                name: "ManageGroupsHome"
            });
        },
        goManageBadges(){
            this.$router.push({
                name: "ManageBadgesHome"
            });
        }
    },
    created() {
        this.groupID = this.$store.getters.getViewGroupID;

        if (this.groupID.trim.length < 1){
            this.groupID = localStorage.getItem('VIEW_GROUP_ID')
        }

        this.groupName = this.$store.getters.getViewGroupName;

        if (this.groupName.trim.length < 1){
            this.groupName = localStorage.getItem('VIEW_GROUP_NAME')
        }
    },
    mounted(){
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.container{
    padding: 10px;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Groups/Students.vue